export default {
  workflowStep: 'App Settings Pane',
  workflowStepCredentials: 'App Credentials Pane',
  credentialEditPage: 'Credential Edit Page',
  appAuthenticationInstance: 'Authentication section of App',
  appActionInstance: 'Test section of App Action',
  appLongPollingActionInstance: 'Polling section of App Action',
  appLongPollingExtraActionInstance: 'Per-Result Polling section of App Action',
  appActionArgumentList: 'Lookup section of App Action Argument',
  appActionArgumentListTest: 'Test section of App Action Argument',
  appActionFilters: 'Filter section of App Action Argument',
  appActionSort: 'Sort section of App Action Argument',
  appActionCustomArguments: 'Custom arguments section of App Action',
  appActionOnCompletionHookActionInstance: 'On Completion Hook section of App Action',
  workflowVariables: 'Workflow Variables in Run Workflow App',
  home: 'Home'
};
